import React from 'react'
import { IDefaultCardImage } from './IDefaultCardImage'
import { NFTFileFormatsEnum } from '../../Card/IDefaultCard'
import ImageSkeleton from '../../../../components/NFTImageSkeleton'
import Loader from '../../../../../../components/Loader'

export default function DefaultCardImage({ item, isCard, baseURI }: IDefaultCardImage) {
  let NFTItem
  let src = item ? item.image : ''
  let fileType = item ? item.type : ''

  if (isCard && item && item.type !== undefined && item.type !== NFTFileFormatsEnum.IMAGE) {
    src = item.coverImage
    fileType = NFTFileFormatsEnum.IMAGE
  }

  src = baseURI + src

  if (fileType === NFTFileFormatsEnum.VIDEO) {
    NFTItem = <video controls={true} controlsList="nodownload" muted={true} autoPlay={true} width="100%" src={src} />
  } else if (fileType === NFTFileFormatsEnum.AUDIO) {
    NFTItem = <video controls={true} controlsList="nodownload" width="100%" src={src} />
  } else if (fileType === NFTFileFormatsEnum.IMAGE) {
    NFTItem = <img src={src} alt="" />
  } else {
    NFTItem = <img src={src} alt="" />
  }

  return item ? NFTItem : <Loader size='32px' />
}
